<template>
  <div class="col-md-12 mx-auto p-0">
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow :title="partenaire != null && partenaire.name ? partenaire.name : 'N/A'" routeBack="PartenaireIndex"/>
        <div>
          <button v-if="isAdmin" class="show-action-btn edit mr-1" @click="clickOnEditBtn()">
            <pencil-icon size="18"/>
          </button>
          <button v-if="isAdmin" class="show-action-btn delete" @click="clickOnDeleteBtn()">
            <trash-icon size="18"/>
          </button>
        </div>
      </div>
      <h2 class="page-subtitle">{{ $t('partenaires.find.2') }}</h2>
      <div class="row">
        <div class="col-md-8">
          <b-card class="mt-2 mb-4 shadow-sm">
            <div class="row">
              <div class="col-md-12">
                <div class="partenaire-name mb-2"> {{ getValue("name") }}</div>
                <div class="page-subtitle"> {{ getValue("categorie") }}</div>
                <div v-if="isAdmin" class="mt-2"> {{ getValue("phoneNumber") }}</div>
                <div v-if="isAdmin" class="mt-2"> {{ getValue("mail") }}</div>
              </div>
              <div class="border-top m-3 w-100">
                <div class="title-second my-2"> {{ $t("partenaire.Description") }}</div>
                <div class="mb-2 partenaire-description" v-html="partenaire.description"></div>
              </div>

              <div class="col-md-12 d-flex justify-content-end">
                <b-button v-if="!isAdmin" @click="openModalPartenaire()" variant="primary"><phone-icon size="18"/>  {{ $t('partenaire.Contact') }}</b-button>
              </div>
            </div>
          </b-card>
        </div>
        <div class="col-md-4">
          <b-card class="mt-2 mb-4 shadow-sm">
            <img v-if="partenaire.logo" :src="getFileUrl(partenaire.logo.fileUrl)" width="100%" height="auto" alt="Photo"/>
            <img v-else :src="require(`@/assets/images/APRILYOS/sidebar-logo.png`)"
                 width="100%" height="auto" alt="Photo"/>
          </b-card>
        </div>
      </div>
    </b-container>

    <Item-delete-modal
      :beginsWithVoyel="false"
      :isFeminine="false"
      :selectedItem="partenaire"
      controllerName="partenaire"
      itemSingularName="partenaire"
      itemSingularNameUpp="Partenaire"
      @didDeleteItem="didDeletePartenaire()">
    </Item-delete-modal>

    <ContactPartenaireModal :key="modalKey" :user-phone="userPhone" :user-mail="userMail" :partenaire="partenaire"/>

  </div>
</template>

<script>

import BackArrow from "../../components/b122/BackArrow";
import ItemDeleteModal from "../../components/b122/ItemDeleteModal";
import api from "../../services/api";
import ContactPartenaireModal from "./ContactPartenaireModal.vue";

export default {
  name: "PartenaireShow",

  components: {
    ContactPartenaireModal,
    BackArrow,
    ItemDeleteModal
  },

  data() {
    return {
      partenaireId: this.$route.params.partenaireId,
      partenaire: {},
      modalKey: 0,
      userPhone: "",
      userMail: "",
      isAdmin: this.$store.getters.isAdmin,
      videoBlobUrl: null, // URL Blob pour la vidéo

    }
  },

  mounted() {
      this.fetchData()
  },

  computed: {
    getValue() {
      return property => (this.partenaire[property] || this.partenaire[property] === false) ? this.partenaire[property] : 'N/A'
    },
  },

  beforeDestroy() {
    if (this.videoBlobUrl) {
      URL.revokeObjectURL(this.videoBlobUrl);
    }
  },


  methods: {

    async fetchData() {
      await this.fetchPartenaire()
      await this.fetchUser()
    },

    async fetchUser() {
      await api
        .get(`/user/getProfile`)
        .then(response => {
          console.log("response", response.data)
          this.userMail = response.data.username
          this.userPhone = response.data.phoneNumber
        })
        .catch((error) => {
          this.$router.push({
            name: '/',
            params: {
              message: error.response.data.message
            }
          })
        })
    },

    getFileUrl(itemUrl) {
      return process.env.SERVER_URL + itemUrl
    },

    async fetchPartenaire() {
      await api
        .get(`/partenaire/${this.partenaireId}`)
        .then(response => {
          this.partenaire = response.data
        })
    },

    clickOnEditBtn() {
      this.$router.push({
        name: 'PartenaireEdit',
        params: {
          partenaireId: this.partenaireId
        }
      })
    },

    clickOnDeleteBtn() {
      if (this.isAdmin) {
        this.$bvModal.show('item-delete-modal')
      }
    },

    openModalPartenaire() {
      this.modalKey++
      setTimeout(() => this.$bvModal.show('contact-partenaire-modal'), 100);
    },

    didDeletePartenaire() {
      this.$router.push({
        name: 'PartenaireIndex'
      })
      this.$nextTick(() => {
        this.successToast(this.partenaire.title)
      })
    },

    successToast(contactName) {
      this.$bvToast.toast(this.$i18n.t('Partenaire') + ' "' + contactName + '" ' + this.$i18n.t('deleted'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    },
  }
}
</script>

<style scoped>

.picture-container {
  width: 100%;
  max-height: 350px;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.picture-container .result-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}



.partenaire-name {
  font-family: "Montserrat-Bold", "Arial", sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0;
}

.title-second {
  font-family: "Montserrat-Medium", "Arial", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0;
  color: #AAAAAA;
}

.partenaire-description {
  font-family: "Montserrat", "Arial", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 130%;
  letter-spacing: 0;
}

/* Forcer les styles pour les éléments HTML dans la description */
.partenaire-description strong {
  font-family: "Montserrat-Bold", "Arial", sans-serif !important;
  font-weight: 700 !important;
}

.partenaire-description b {
  font-family: "Montserrat-Bold", "Arial", sans-serif !important;
  font-weight: 700 !important;
}

.partenaire-description em {
  font-style: italic !important;
}

.partenaire-description s {
  text-decoration: line-through !important;
}

</style>



// WEBPACK FOOTER //
// src/views/partenaire/PartenaireShow.vue